<template>
  <vs-popup :title="$t('Description')" :active.sync="showModal">
    <div>
      <label for="">{{ $t("Description") }}:</label>
      <vs-textarea
        v-model="model.description"
        placeholder="توضیحات برای تدبیر"
        name=""
        cols="90"
        rows="3"
      />
      <label for="">{{ $t("Considerations") }}:</label>
      <vs-textarea
        v-model="model.considerations"
        placeholder="ملاحضات درون‌سازمانی"
        name=""
        cols="90"
        rows="3"
      />
      <div class="flex justify-end my-3">
        <vs-button class="vs-button" @click="submitForm()" id="l-confirm-btn">{{
          $t("Confirm")
        }}</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "basketManagement_ChannelBaskets_imagePopup",
  props: {
    show: { default: false },
    referencePageInfo: { default: {} },
    dischargePermissionId: "",
  },
  data() {
    return {
      model: {
        dischargePermissionId: "",
        description: "",
        considerations: "",
      },
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  methods: {
    ...mapActions({
      confirm: "dischargePermissions/confirmDischargePermission",
    }),
    submitForm() {
      this.model.dischargePermissionId = this.dischargePermissionId;
      this.confirm(this.model).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          this.$emit("finish");
          this.$router.push({
            path: "/DischargePermissions/Index",
            query: { referencePageInfo: this.referencePageInfo },
          });
        }, 3000);
      });
    },
  },
};
</script>
